<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'MaUserInput',
})
</script>
<template>
	<el-input v-model="userName" :readonly :clearable :disabled :placeholder @clear="model = ''">
		<template #append>
			<el-button icon="Search" @click="visible = true"></el-button>
		</template>
	</el-input>
	<ma-user-dialog
		v-if="!disabled && visible"
		:key="visible"
		v-model="visible"
		:multiple
		:default-selected="getCurrentSelectedIds()"
		@select="select"
	></ma-user-dialog>
</template>

<script setup lang="ts" name="MaUserInput">
import { ref, watch } from 'vue'
import { useRealNameListApi } from '@/api/sys/user'

const props = defineProps({
	multiple: {
		type: Boolean,
		required: false,
		default: false
	},
	clearable: {
		type: Boolean,
		required: false,
		default: () => true
	},
	disabled: {
		type: Boolean,
		required: false,
		default: () => false
	},
	placeholder: {
		type: String,
		required: false,
		default: () => ''
	},
	readonly: {
		type: Boolean,
		required: false,
		default: () => true
	}
})

const model = defineModel<any | any[]>()
const visible = ref(false)
const userName = ref()
// 保存完整的用户信息
const selectedUsers = ref<any[]>([])

const handleSelect = async (val: any) => {
	if (val) {
		const idList = props.multiple ? val : [val]
		if (idList.length > 0) {
			const { data } = await useRealNameListApi(idList)
			userName.value = data.join(',')
		} else {
			userName.value = ''
		}
	} else {
		userName.value = ''
		selectedUsers.value = []
	}
}
watch(
	() => model.value,
	async val => handleSelect(val),
	{
		immediate: true
	}
)

// 获取当前已选设备ID列表
const getCurrentSelectedIds = () => {
	if (!model.value) {
		return []
	}
	if (props.multiple) {
		if (Array.isArray(model.value)) {
			return model.value
		}
		if (typeof model.value === 'string') {
			return model.value.split(',').filter(id => id.trim())
		}
	}
	return [model.value]
}

const emit = defineEmits(['select', 'change'])
const select = (rows: any[]) => {
	// 保存完整的用户信息
	selectedUsers.value = rows

	if (props.multiple) {
		let arr = rows.map((item: any) => item.id)
		handleSelect(arr)
		model.value = rows.map((e: any) => e.id)
	} else {
		model.value = rows[0].id
		handleSelect(rows[0].id)
	}
	emit('select', rows)
	const changeData = {
		ids: props.multiple ? rows.map((e: any) => e.id) : rows[0]?.id,
		users: rows
	}
	emit('change', changeData)
}
</script>
